export default __webpack_public_path__ + "static/media/close-modal.436edf55.svg";